<template>
<!--  <SubContent @back="$router.push('/home/index')">-->
  <SubContent @back = "back">
    <template v-slot:nav_left>
<!--      <div class="nav_wrap">-->
<!--        <div class="nav_list">-->
<!--          <div v-for="(item, index) in navList" :key="index">-->
<!--            <span-->
<!--              v-if="userRole !== 'coach' && index === 0"-->
<!--              style="display: none"-->
<!--            ></span>-->
<!--            <span-->
<!--              v-else-->
<!--              class="nav_item"-->
<!--              :class="idx === index ? 'active' : ''"-->
<!--              @click="changeNav(index)"-->
<!--              >{{ item }}</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <template v-if="userRole === 'system' || userRole === 'admin' || userRole === 'expert'">
        日计划训练实施（{{youthShortName}}）
      </template>
      <template v-else>
        日计划训练实施
      </template>
    </template>


    <template v-slot:nav_right>
      <div class="select_wrap">
        <template v-if="userRole === 'coach'">
          <div class="yioks_btn" @click="openSelectDialog">添加新的日计划</div>
          <!-- <div class="yioks_btn" @click="addPlain"> 添加计划</div> -->
          <!-- <div v-else class="yioks_btn"  style="background-color: gray;cursor: not-allowed"> 添加计划</div> -->
        </template>
      </div>
    </template>
    <div
      class="select_wrap"
      style="padding: 20px 40px 0 40px"
      v-if="userRole !== 'player'"
    >
<!--      因为有周计划了，暂时隐藏-->
<!--      <div class="select_box">-->
<!--        <template v-if="userRole !== 'coach'">-->
<!--          <select-->
<!--            v-model="selectVal.organUuid"-->
<!--            class="yioks_select"-->
<!--            @change="changeOrg"-->
<!--          >-->
<!--            <option value="" v-if="organList.length !== 1">-->
<!--              全部区体育行政部门-->
<!--            </option>-->
<!--            <option-->
<!--              v-for="item in organList"-->
<!--              :key="item.organUuid"-->
<!--              :value="item.organUuid"-->
<!--            >-->
<!--              {{ item.organShortName }}-->
<!--            </option>-->
<!--          </select>-->
<!--          <select-->
<!--            v-model="selectVal.youthUuid"-->
<!--            class="yioks_select"-->
<!--            @change="changeCenter"-->
<!--          >-->
<!--            <option value="" v-if="centerList.length !== 1">-->
<!--              全部培训机构-->
<!--            </option>-->
<!--            <option-->
<!--              v-for="item in centerList"-->
<!--              :key="item.uuid"-->
<!--              :value="item.uuid"-->
<!--            >-->
<!--              {{ item.youthShortName }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </template>-->

<!--        <template v-else>-->
<!--          <select-->
<!--            v-model="selectVal.squadUuid"-->
<!--            class="yioks_select"-->
<!--            @change="changeQuery(true)"-->
<!--          >-->
<!--            <option value="" v-if="squadList.length !== 1">全部球队</option>-->
<!--            <option-->
<!--              v-for="item in squadCoachList"-->
<!--              :key="item.key"-->
<!--              :value="item.value"-->
<!--            >-->
<!--              {{ item.label }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </template>-->
<!--      </div>-->
      <div class="search_box">
        <select
          v-model="selectVal.status"
          class="yioks_select"
          @change="changeQuery(true)"
        >
          <option value="">全部状态</option>
          <option value="INITIATED">编写中</option>
          <option value="INCOMPLETE">待实施</option>
          <option value="COMPLETE">已完成</option>
        </select>
      </div>
      <div class="search_box">
        <input
          v-model.trim="selectVal.seacherString"
          type="text"
          class="yioks_input"
          style="width: 200px"
          placeholder="请输入关键字"
          @keyup.enter="changeQuery(true)"
        />
        <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
      </div>
    </div>
    <yioks-tip
      :showTip="showTip"
      :tipMsg="$t('deletePlanTips')"
      @callback="isDelete"
    ></yioks-tip>
    <yioks-tip
      :showTip="showBackTip"
      :tipMsg="$t('backPlanTips')"
      @callback="isBack"
    ></yioks-tip>
    <yioks-tip
      :showTip="showTipXiuxi"
      tipMsg="确定设置本日为休息日吗？"
      @callback="isSetXiuxi"
    ></yioks-tip>
    <!--        <yioks-empty v-if="empty"></yioks-empty>-->
    <div class="list_wrap">
      <div v-if="dataReady" class="table">
        <div class="thead">
          <div class="tr">
            <div class="th squadName"><strong>所属球队</strong></div>
            <div class="th trainingTime"><strong>训练开始时间</strong></div>
            <div class="th trainingPlace"><strong>训练地点</strong></div>
            <div class="th name"><strong>训练主题</strong></div>
            <!--<div class="th trainingAmount"><strong>训练量</strong></div>-->
            <!--<div class="th trainingAmount"><strong>强度</strong></div>-->
            <!--<div class="th trainingAmount"><strong>时长</strong></div>-->
            <div class="th trainingAmount"><strong>状态</strong></div>
            <div class="th opt"><strong>操作</strong></div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <div class="tbodyWrap">
              <div class="tbody">
                <div v-for="(item, index) in plainList" :key="index" class="tr">
                  <div class="td squadName" :title="item.squadName">
                    <p>{{ item.squadName || "--" }}</p>
                  </div>
                  <div class="td trainingTime" :title="item.trainingTime | time(true)">
                    <p>{{ item.trainingTime | time(true) }}</p>
                  </div>
                  <div class="td trainingPlace" :title="item.trainingPlace">
                    <p>{{item.trainingPlace || "--"}}</p>
                  </div>
                  <template v-if="item.trainingStatus !== 'INITIATED' && item.trainingName !== '休息'">
                    <div class="td name" :title="item.trainingName">
                      <p><span class="itemName" @click="goDetail(item.uuid)">{{item.trainingName || "--"}}</span></p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="td name" :title="item.trainingName">
                      <p>{{ item.trainingName || "--" }}</p>
                    </div>
                  </template>
                  <!--<div class="td trainingAmount" :title="item.trainingAmount">-->
                    <!--<p>{{ item.trainingAmount || "&#45;&#45;" }}</p>-->
                  <!--</div>-->
                  <!--<div class="td trainingAmount">-->
                    <!--<p>{{ item.trainingIntensity || "&#45;&#45;" }}</p>-->
                  <!--</div>-->
                  <!--<div class="td trainingAmount">-->
                    <!--<template v-if="item.trainingTotalTime" :title="`${item.trainingTotalTime}分钟`">-->
                      <!--<p>{{ item.trainingTotalTime || "0" }}分钟</p>-->
                    <!--</template>-->
                    <!--<template v-else>-->
                      <!--<p>&#45;&#45;</p>-->
                    <!--</template>-->
                  <!--</div>-->
                  <div class="td trainingAmount">
                    <template v-if="item.trainingName === '休息'">
                      <p>--</p>
                    </template>
                    <template v-else>
                      <p>{{ item.trainingStatus | trainingStatus }}</p>
                    </template>
                  </div>
                  <div class="td opt">
                    <p>
                      <template v-if="item.trainingStatus === 'INITIATED'"> <!--开始创建-->
                        <template v-if="userRole === 'coach'">
                          <template v-if="item.trainingName !== '休息' && !isNotEdit">
                            <span class="item" @click="editTrainPlain(item, item.uuid,item.squadUuid)">编辑日计划</span>
                            <span class="split">/</span>
                          </template>
                          <span class="item" @click="deleteTrainPlain(item.uuid)">删除</span>
                          <div v-if="item.trainingName !== '休息' && !isNotEdit">
                            <span class="item" @click="setXiuxi(item.uuid)">设置为休息</span>
                          </div>
                        </template>
                        <template v-else>
                          <span>--</span>
                        </template>
                      </template>
                      <template v-if="item.trainingStatus === 'INCOMPLETE'"><!--未完善-->
                        <template v-if="item.trainingName !== '休息'">
                          <template v-if="userRole === 'coach' && !isNotEdit">
                            <div>
                              <span class="item" @click="editTrainPlain(item,item.uuid,item.squadUuid,'INCOMPLETE')">编辑日计划</span>
                              <span class="split">/</span>
                              <span class="item" @click="deleteTrainPlain(item.uuid)">删除</span>
                            </div>
                            <div>
                              <span class="item" @click="setXiuxi(item.uuid)">设置为休息</span>
                            </div>
                          </template>
                          <template v-else>
                            <span class="item" @click="goDetail(item.uuid)">查看</span>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="userRole === 'coach'">
                            <span class="item" @click="deleteTrainPlain(item.uuid)">删除</span>
                          </template>
                          <template v-else>
                            <span>--</span>
                          </template>
                        </template>
                      </template>
                      <template v-if="item.trainingStatus === 'COMPLETE'"><!--已完善-->
                        <template v-if="item.trainingName === '休息'">
                          <template v-if="userRole === 'coach'">
                            <span class="item" @click="deleteTrainPlain(item.uuid)">删除</span>
                          </template>
                          <template v-else>
                            <span>--</span>
                          </template>
                        </template>
                        <template v-else>
                          <template v-if="userRole === 'system' || userRole === 'admin' || userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">
                            <span class="item" @click="backTrainPlain(item.uuid)">退回</span>
                            <span class="split">/</span>
                          </template>
                          <template v-if="userRole !== 'player'">
                            <span class="item" @click="download(item.uuid)">下载</span>
                          </template>
                        </template>
                      </template>
                    </p>
                  </div>
<!--                  <div class="td opt">-->
<!--                    <p>-->
<!--                      <template v-if="idx === 0">-->
<!--                        <span-->
<!--                          class="item"-->
<!--                          @click="editTrainPlain(item, item.uuid,item.squadUuid)"-->
<!--                          >编辑日计划</span-->
<!--                        >-->
<!--                        <span class="split">/</span>-->
<!--                        <span class="item" @click="deleteTrainPlain(item.uuid)"-->
<!--                          >删除</span-->
<!--                        >-->
<!--                      </template>-->
<!--                      <template v-if="idx === 1">-->
<!--                        <template v-if="userRole === 'coach'">-->
<!--                          <span class="item" @click="editTrainPlain(item,item.uuid,item.squadUuid,'INCOMPLETE')">编辑日计划</span>-->
<!--                          <span class="split">/</span>-->
<!--                          <span class="item" @click="deleteTrainPlain(item.uuid)" >删除</span>-->
<!--                          <span class="split">/</span>-->
<!--                        </template>-->
<!--                        <span class="item" @click="goDetail(item.uuid)">查看</span>-->
<!--                      </template>-->
<!--                      <template v-if="idx === 2">-->
<!--                        <template v-if="userRole === 'system' || userRole === 'admin' || userRole === 'youth' || userRole === 'trainCamp' || userRole === 'club'">-->
<!--                          <span class="item" @click="backTrainPlain(item.uuid)"-->
<!--                            >退回</span-->
<!--                          >-->
<!--                        </template>-->
<!--                        <template v-else>-->
<!--                          <span class="item" @click="goDetail(item.uuid)"-->
<!--                            >查看</span-->
<!--                          >-->
<!--                        </template>-->
<!--                        <template v-if="userRole !== 'player'">-->
<!--                          <span class="split">/</span>-->
<!--                          <span class="item" @click="download(item.uuid)"-->
<!--                            >下载</span-->
<!--                          >-->
<!--                        </template>-->
<!--                      </template>-->
<!--                    </p>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
      <yioks-loading v-if="loading" />
      <yioks-empty v-if="empty" />
      <el-dialog
        title="请选择单位"
        :visible.sync="isOpenTrainingAdd"
        width="500px"
        :before-close="dialogBeforeClose"
      >
        <div class="add-wrapper">
          <el-select
            class="add-select"
            clearable=""
            v-model="addTraingingSquadUuid"
            placeholder="请选择球队"
            disabled
          >
            <el-option
              v-for="item in squadCoachList"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

<!--          <div class="ac-type">-->
<!--            <el-radio-group v-model="planeType">-->
<!--              <el-radio label="byTrain">通过教案创建</el-radio>-->
<!--              <el-radio label="byDoc">通过文件创建</el-radio>-->
<!--            </el-radio-group>-->
<!--          </div>-->
        </div>
        <div slot="footer" class="add-footer">
          <el-button type="primary" @click="addPlain">确 定</el-button>
          <el-button type="danger" @click="isOpenTrainingAdd = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>
    <Pagination :total="total" :page.sync="page" />
  </SubContent>
</template>

<script>
import "vue-awesome/icons/plus";
import common from "@/api/common";
import storage from "@/utils/storage";
import training from "@/api/training";
import squad from "@/api/squad";
import plan from "@/api/plan";

export default {
  components: {
    SubContent: () => import("@/components/layout/newSubContent"),
    Pagination: () => import("@/components/Pagination"),
  },

  filters: {
    trainingStatus (val) {
      switch (val) {
        case 'INITIATED': return '编写中'
        case 'INCOMPLETE': return '待实施'
        case 'COMPLETE': return '已完成'
        default: return '--'
      }
    }
  },
  data() {
    return {
      downIng: false,
      // navList: ["编写日计划", "待实施日计划", "已完成日计划"],
      navList: ["日训练计划"],
      page: 0,
      pageSize: 20,
      total: 0,
      userRole: storage.get("userInfo").userRole,
      idx: 0,
      loading: true,
      empty: false,
      dataReady: false,
      squadList: [],
      chiefCoachName: "",
      plainList: [],
      showTip: false,
      showTipXiuxi: false,
      showBackTip: false,
      isNotEdit: false,
      deleteUuid: "", // 要被删除训练计划的uuid
      setXiuxiUuid: "", // 要设置为休息的训练计划的uuid
      backUuid: "", // 要被退回训练计划的uuid
      organList: [],
      centerList: [],
      selectVal: {
        seacherString: this.$route.query.key || "",
        youthUuid: this.$route.query.youthUuid || "",
        organUuid: this.$route.query.organUuid || "",
        squadUuid: this.$route.query.squadUuid || "",
        status: this.$route.query.status || "",
      },
      squadCoachList: [], // coach 专用搜索选项
      addTraingingSquadUuid: "",
      isOpenTrainingAdd: false,
      // planeType: "byTrain", // 暂时不需要
      aheadTrainingStartTime: "",
      aheadTrainingEndTime: "",
      aheadTrainingUuid: "",
    };
  },
  watch: {
    page() {
      this.changeQuery();
    },
    // 跟换球队时相应的修改 主教练 用于添加时传递
  },
  computed: {
    youthShortName() {
      const { youthShortName } = this.$route.query;
      return youthShortName;
    },
  },
  created() {
    // const { idx, squadUuid, organUuid, youthUuid,aheadTrainingStartTime,aheadTrainingEndTime,aheadTrainingUuid } = this.$route.query;
    const {squadUuid, organUuid, youthUuid,aheadTrainingStartTime,aheadTrainingEndTime,aheadTrainingUuid } = this.$route.query;
    // let id;
    // if (this.userRole !== "coach") {
    //   id = 1;
    // } else {
    //   id = 0;
    // }
    // this.idx = idx ? Number(idx) : id;
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    squadUuid && this.$set(this.selectVal, "squadUuid", squadUuid);
    aheadTrainingStartTime && this.$set(this.selectVal, "aheadTrainingStartTime", aheadTrainingStartTime);
    aheadTrainingEndTime && this.$set(this.selectVal, "aheadTrainingEndTime", aheadTrainingEndTime);
    aheadTrainingUuid && this.$set(this.selectVal, "aheadTrainingUuid", aheadTrainingUuid);
    // this.getCommonData()
    if (this.userRole !== "coach") {
      this.getOrganList();
    } else {
      this.getCoachOrganList();
    }
    
    this.getAheadTrainView(aheadTrainingUuid);
  },
  methods: {
    getOrganList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        // 这段代码将被短路不适用
        request = squad.getOrgListByCoachOrLeader;
      }
      request(data).then((res) => {
        this.organList = res;
        if (this.selectVal.organUuid) {
          if (this.selectVal.youthUuid) {
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.selectVal.squadUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        } else {
          if (res.length === 1) {
            this.$set(this.selectVal, "organUuid", res[0].organUuid);
            this.centerList =
              this.organList.find((item) => {
                return item.organUuid === this.selectVal.organUuid;
              }).youthList || [];
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
              }
            }
            if (this.selectVal.youthUuid) {
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.selectVal.youthUuid;
                }).squadList || [];
            }
          }
        }
      });
    },
    getCoachOrganList() {
      const _ = require("lodash");
      squad.getSquadListCoachAll().then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        const uni_selectYouthList = _.unionBy(res, "squadUuid");
        this.squadCoachList = uni_selectYouthList.map((item) => ({
          label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
          value: item.squadUuid,
          key: JSON.stringify({
            squadUuid: item.squadUuid,
            youthUuid: item.youthUuid,
            organUuid: item.organUuid,
          }),
        }));
      });
    },
    // changeNav(index) {
    //   // 防止重复点击
    //   if (index === this.idx) return;
    //   // 跟换球队时调用此方法必传 index === 3 ,此时不改变 idx
    //   if (index !== 3) this.idx = index;
    //   this.changeQuery(true);
    // },
    getTrainPlan() {
      this.loading = true;
      this.empty = false;
      this.dataReady = false;

      // // 根据胡总需求，页面显示为一个，所以隐藏掉了
      // let status = "";
      // if (this.idx === 0) {
      //   status = "INITIATED";
      // } else if (this.idx === 1) {
      //   status = "INCOMPLETE";
      // } else if (this.idx === 2) {
      //   status = "COMPLETE";
      // }
      let request;
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = training.getTrainPlanListSystem;
      } else if (this.userRole === "organ") {
        request = training.getTrainPlanListOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = training.getTrainPlanListYouth;
      } else if (this.userRole === "coach" || this.userRole === "leader") {
        request = training.getTrainPlanListCoach;
      } else if (this.userRole === "player") {
        request = training.getTrainPlanListPlayer;
      }
      let data = {
        // status,
        page: this.page,
        size: this.pageSize,
        squadUuid: this.selectVal.squadUuid,
        organUuid: this.selectVal.organUuid,
        key: this.selectVal.seacherString,
        status: this.selectVal.status,
        youthUuid: this.selectVal.youthUuid,
        aheadTrainingUuid: this.selectVal.aheadTrainingUuid,
      };
      request(data)
        .then((res) => {
          this.loading = false;
          if (res.totalElements) {
            this.dataReady = true;
            this.plainList = res.content;
            this.total = res.totalElements;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    getAheadTrainView(aheadTrainingUuid) {
      plan.getAheadTrainListView(aheadTrainingUuid)
        .then((res) => {
          const now = new Date();
          const fourteenDaysLater = new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000); // 十四天前  第14天也可以编辑
          if (res.aheadTrainingEndTime < fourteenDaysLater.getTime()) {
            // 结束14天了
//            this.isNotEdit = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
  
      this.getTrainPlan();
    },
    openSelectDialog() {
      // this.isOpenTrainingAdd = true; // 隐藏选择球队功能，直接进入到添加页面
      // 根据传参带过来的球队uuid、开始时间、结束时间创建训练计划
      this.addTraingingSquadUuid = this.selectVal.squadUuid;
      this.aheadTrainingStartTime = this.selectVal.aheadTrainingStartTime;
      this.aheadTrainingEndTime = this.selectVal.aheadTrainingEndTime;
      this.aheadTrainingUuid = this.selectVal.aheadTrainingUuid;
      this.addPlain()
    },
    addPlain() {
      if (this.addTraingingSquadUuid) {
        const queryData = {
          squadUuid: this.addTraingingSquadUuid,
          // planeType: this.planeType,
          aheadTrainingStartTime: this.aheadTrainingStartTime,
          aheadTrainingEndTime: this.aheadTrainingEndTime,
          aheadTrainingUuid: this.aheadTrainingUuid,
          // squadUuid: this.selectVal.squadUuid
        };
        this.addTraingingSquadUuid = "";
        this.$router.push({
          path: "addPlain",
          query: queryData,
        });
        this.isOpenTrainingAdd = false;
      } else {
        this.$message.warning('请选择球队')
      }
    },
    dialogBeforeClose() {
      this.addTraingingSquadUuid = "";
      this.aheadTrainingStartTime = "";
      this.aheadTrainingEndTime = "";
      this.aheadTrainingUuid = "";
      this.isOpenTrainingAdd = false;
    },
    deleteTrainPlain(uuid) {
      this.showTip = true;
      this.deleteUuid = uuid;
    },
    setXiuxi(uuid) {
      this.showTipXiuxi = true;
      this.setXiuxiUuid = uuid;
    },
    backTrainPlain(uuid) {
      this.showBackTip = true;
      this.backUuid = uuid;
    },
    isDelete(isSure) {
      if (isSure) {
        training.deleteEvent({ trainPlanUuid: this.deleteUuid }).then((res) => {
          this.showTip = false;
          this.getTrainPlan();
        });
      } else {
        this.showTip = false;
      }
    },
    isSetXiuxi(isSure) {
      if (isSure) {
        training.XiuxiEvent({ trainPlanUuid: this.setXiuxiUuid }).then((res) => {
          this.showTipXiuxi = false;
          this.getTrainPlan();
        });
      } else {
        this.showTipXiuxi = false;
      }
    },
    isBack(isSure) {
      if (isSure) {
        training.backEvent({ trainPlanUuid: this.backUuid }).then((res) => {
          this.showBackTip = false;
          this.getTrainPlan();
        });
      } else {
        this.showBackTip = false;
      }
    },
    // 已完成计划，查看详细
    goDetail(uuid) {
      this.$router.push({
        path: "detail",
        query: { uuid },
      });
    },
    download(uuid) {
      if (this.downIng) return;
      this.downIng = true;
      training
        .downloadPlan({ trainingPlanUuid: uuid })
        .then((res) => {
          const { fileName, filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          common.downfile(transferPath, fileName);
          this.downIng = false;
        })
        .catch((err) => {
          this.downIng = false;
        });
    },
    // 编辑只能跳转到第一步，和第二步，第三步保存就不能编辑了，所以对第一第二步跳转传不同参数
    // 为了使用下去，，，所以别好奇为什么有row对象，还单独传值uuid等等等，问就是历史原因。用就行；zzh
    editTrainPlain(row, uuid, squadUuid,type ) {
      const { fileStatus } = row;
      // let data = { uuid, squadUuid: this.squadUuid, planeType: fileStatus == 1 ? "byDoc" : "byTrain", };
      this.aheadTrainingStartTime = this.selectVal.aheadTrainingStartTime;
      this.aheadTrainingEndTime = this.selectVal.aheadTrainingEndTime;
      this.aheadTrainingUuid = this.selectVal.aheadTrainingUuid;
      let data = {
        uuid,
        squadUuid: squadUuid,
        // planeType: fileStatus === 1 ? "byDoc" : "byTrain", // 暂时不需要
        aheadTrainingStartTime:this.aheadTrainingStartTime,
        aheadTrainingEndTime:this.aheadTrainingEndTime,
        aheadTrainingUuid:this.aheadTrainingUuid,
      };
      if (type === "INCOMPLETE") //待实施
        data = {
          idx: 1, // 第二步待实施，必传，用来判断显示第几步的
          trainingStatus: type,
          // squadUuid: this.squadUuid,
          squadUuid: squadUuid,
          uuid,
          // planeType: fileStatus === 1 ? "byDoc" : "byTrain", // 暂时不需要
          aheadTrainingStartTime:this.aheadTrainingStartTime,
          aheadTrainingEndTime:this.aheadTrainingEndTime,
          aheadTrainingUuid:this.aheadTrainingUuid,
        };
      this.$router.push({
        path: "addPlain",
        query: data,
      });
    },
    // 因为有周计划了，暂时隐藏
    // changeOrg() {
    //   this.squadList = [];
    //   this.centerList = [];
    //   this.$set(this.selectVal, "youthUuid", "");
    //   this.$set(this.selectVal, "squadUuid", "");
    //   if (this.selectVal.organUuid) {
    //     const { youthList } = this.organList.find((item) => {
    //       return item.organUuid === this.selectVal.organUuid;
    //     });
    //     this.centerList = youthList || [];
    //     if (this.centerList.length === 1) {
    //       this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
    //       this.squadList =
    //         this.centerList.find((item) => {
    //           return item.uuid === this.selectVal.youthUuid;
    //         }).squadList || [];
    //       if (this.squadList.length === 1) {
    //         this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
    //       }
    //     }
    //   }
    //   this.changeQuery(true);
    // },
    // changeCenter() {
    //   this.squadList = [];
    //   this.$set(this.selectVal, "squadUuid", "");
    //   if (this.selectVal.youthUuid) {
    //     this.squadList =
    //       this.centerList.find((item) => {
    //         return item.uuid === this.selectVal.youthUuid;
    //       }).squadList || [];
    //     if (this.squadList.length === 1) {
    //       this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
    //     }
    //   }
    //   this.changeQuery(true);
    // },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          // idx: this.idx, // 按照胡总要求列表为一个页面，暂时不需要了
          key: this.selectVal.seacherString,
          status: this.selectVal.status,
          squadUuid: this.selectVal.squadUuid,
          organUuid: this.selectVal.organUuid,
          youthUuid: this.selectVal.youthUuid,
          aheadTrainingStartTime: this.selectVal.aheadTrainingStartTime,
          aheadTrainingEndTime: this.selectVal.aheadTrainingEndTime,
          aheadTrainingUuid: this.selectVal.aheadTrainingUuid,
        },
      });
      this.getTrainPlan();
    },


    back(){
      if (this.userRole === "coach"){
        // this.$router.go(-1)
        this.$router.push('/plan/list')
      }else {
        this.$router.go(-1)
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.select_wrap
  padding 0
.nav_wrap
  display flex
  justify-content space-between
  font-size 16px
  .nav_list
    display flex
    .nav_item
      cursor pointer
      user-select none
      padding 10px 20px
      &.active
        background $green_color
  .btn_wrap
    display flex
    align-items center
    padding-right 20px
    .disabledBtn
      background-color gray
      cursor not-allowed
.list_wrap
  margin-top 40px
  height 425px
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
      .itemName
        cursor pointer
        user-select none
        color $green_color
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .squadName
      width 19%
    .seq
      width 7%
    .name
      width 18%
    .trainingAmount
      width 7%
    .trainingTime
      width 19%
    .trainingPlace
      width 19%
    .opt
      // width 12%
      flex 1
      width 8%
      p
        width 100%
        text-align center
        white-space normal
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.add-wrapper
  display flex
  padding 0 30px
  flex-direction column
  .ac-type
    margin-top 20px
  .add-select
    width 100%
.add-footer
  width 40%
  margin 0 auto
  display flex
  justify-content space-around
</style>
